import type { DraftPath } from '../types/parameters.types';

export const setAtPath = <T>(source: T, path: DraftPath, value: unknown): T => {
	if (path.length === 0) return value as T;
	const [head, ...rest] = path;
	const container = (source ?? {}) as Record<string | number, unknown>;
	const clone: Record<string | number, unknown> | unknown[] = Array.isArray(container)
		? [...container]
		: { ...container };
	(clone as Record<string | number, unknown>)[head] = setAtPath(container[head], rest, value);
	return clone as T;
};
